// extracted by mini-css-extract-plugin
export default {"breadCrumbContainer":"styles_breadCrumbContainer__xLlU0","breadCrumb":"styles_breadCrumb__UVKXv"};